import type { MapSearchInput } from '@/shared/utils/queryUtils'

export const membersTableFields: MapSearchInput['path'] = {
    email: 'email'
}
